import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UpgradeModalComponent, UpgradeModalOptions } from './upgrade-modal.component';

/**
 * SD-1229: opens the upgrade modal from any page:
 *   this.upgradeModal.open({ reason: 'inbox-automator', requiredFeature: 'emails.inbox-automator' })
 * Resolves true when the organisation's plan was bought or changed, false otherwise.
 */
@Injectable({ providedIn: 'root' })
export class UpgradeModalService {
  private opening: Promise<boolean> | null = null;

  constructor(private modal: NgbModal) { }

  open(options: UpgradeModalOptions = {}): Promise<boolean> {
    // Two prompts at once (a 403 and a click, say) should not stack two checkouts.
    if (this.opening) { return this.opening; }

    const ref = this.modal.open(UpgradeModalComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      scrollable: false,
      windowClass: 'synced-dialog synced-dialog--form synced-dialog--wide synced-dialog--elevated',
      backdropClass: 'synced-dialog-backdrop synced-dialog-backdrop--elevated'
    });
    ref.componentInstance.options = options || {};

    this.opening = ref.result
      .then(bought => !!bought, () => false)
      .finally(() => this.opening = null);
    return this.opening;
  }
}
